import { ContactConfig } from './Contact';
import { EventTypeProps } from './EventType';
import { LocalizedText } from './LocalizedText';
import { QuestionChoiceApiProps, QuestionChoiceProps } from './QuestionChoice';
import { QuestionDependencyProps } from './QuestionDependency';

export interface QuestionProps {
  activityId: number;
  choices?: unknown[];
  questionChoices?: QuestionChoiceProps[];
  contactConfig?: ContactConfig;
  dataType: string;
  id: number;
  includeInTotal?: boolean;
  hourlyVolunteerRate?: number;
  maxCharacters?: number;
  parentQuestion?: QuestionDependencyProps[];
  parentValue?: number;
  questionNeeded: boolean;
  questionNote: string;
  questionOrder: number;
  questionText: string;
  questionType: string;
  alias: string;
  eventType: EventTypeProps | null;
  datePickerRangeId?: number | null;
}

export interface QuestionApiProps extends Omit<
  QuestionProps,
  'questionChoices' | 'questionNote' | 'questionText'
> {
  questionChoices?: QuestionChoiceApiProps[];
  // Backward-compatible payload keys.
  questionNote?: LocalizedText;
  questionText?: LocalizedText;
  // Current payload keys.
  questionNoteTranslations?: LocalizedText;
  questionTextTranslations?: LocalizedText;
}

export interface SignatureQuestionResponse {
  signatureApplicationRelationshipId: number | null;
  signatureId: number | null;
  applicationId: string | number | null;
  questionId: number | null;
  imageUrl: string | null;
  date: string | null;
}

export enum QuestionAlias {
  TCOW_Expenditure_Currency = 'TCOW_Expenditure_Currency',
  TCOW_Check_Eligibility_Box = 'TCOW_Check_Eligibility_Box',
}
